import { Component, ViewChild } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import { NavController, ToastController, LoadingController, AlertController, ViewController, Config, Select   } from 'ionic-angular';

import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';


import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { UserMyRadiant, RepositoryMyRadiant, HelperMyRadiant, PresensiProvider } from '../../../../providers';
import { cmpFilterKaryawan } from '../../../../components/presensi';

@Component({
  selector: 'presensi-detail',
  templateUrl: 'page.html'
})
export class DetailPresensi {
  loading : any;
  isLogin : any = 0;
  data = {
    attendance:[],
    dateMulai:"",
    dateAkhir:"",
    dateJarak:"",
    employee :"Me",
    title:"",
  };
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.Employee_ID,
    nik : this.userApi.data.NIK,
    date_start : '2020-02-01',
    date_end : '2020-02-29',
    token:1,
  }
  @ViewChild('filterKaryawan') selectRef: Select;
  constructor(
    public navCtrl        : NavController,
    public toastCtrl      : ToastController,
    public loadingCtrl    : LoadingController,
    public alertCtrl      : AlertController,
    public userApi        : UserMyRadiant,
    public menuCtrl       : MenuController,
    public modalCtrl      : ModalController,
    public nav            : Nav,
    public navParams      : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    public config         : Config,
    public sanitizer      : DomSanitizer,
    public events         : Events,
    public presensiProvider : PresensiProvider,
  ) {
    this.config.set('backButtonText','Presensi');
  	this.valDateJarak = {
  		from:this.today.obj.awal,
  		to:this.today.obj.akhir
    };
    // console.log(this.navParams);
    this.data.title = this.navParams.get('month')+' '+this.navParams.get('year');
    // this.parameter.month = this.navParams.get('month')+'-'+this.navParams.get('year');
    this.parameter.id = this.navParams.get('Employee');
    let params_date = this.navParams.get('date').split('/');
    let month = parseInt(params_date[1]);
    this.parameter.date_start = params_date[0] + '-' + ((month < 10) ? '0' + month : month) + '-01';
    this.parameter.date_end = params_date[0] + '-' + ((month + 1 < 10) ? '0' + (month + 1) : (month+1)) + '-0';;
    this.getAttendance();
    localStorage.setItem('presensi_karyawan_attendance','me');
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  filterKaryawan(){
    let me = this;
    this.showLoading();
    this.repositoryProvider.getBawahan(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {karyawan:resp.data}, {cssClass: 'select-modal',enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          if(karyawan){
            if (karyawan=='me') {
              me.data.employee = "Me";
              me.parameter.nik = this.userApi.data.NIK;
            }else{
              me.data.employee = karyawan.name;
              me.parameter.nik = karyawan.nik;
            }
            me.getAttendance();
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }

  getAttendance(){
    let me = this;
    this.loading = this.helper.showLoading('Loading Data..');
    this.repositoryProvider.getListAttendance(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.attendance = [];
        resp.data.forEach(row => {
          // if(row.Productivity != null){
          //   row.Productivity = parseInt(row.Productivity).toFixed(2)+'%';
          // }
          me.data.attendance.push(row);
        });
       
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  changeProductivity(data){
    let me = this;

    let akses = this.userApi.akses;
    if (akses['edit_presentase_presensi']) {
      let element_content = `
        <div class="background-biru-muda" style="width:100%;padding: 1px 10px;" >
          <p class="text-abu">`+ data.string_date+`<p >
          <div style="display: inline-grid;grid-template-columns:50% 50%;width:100%;">
              <div>
                <p class="text-abu" style="margin:0px;font-size:12px;">In</p>
                <div class="swal-title" style="padding:0px !important;">
                  `+this.helper.ifvalnull(data.TimeIn,'').substring(0,5)+`
                </div>
              </div>
              <div>
                <p class="text-abu" style="margin:0px;font-size:12px;">Out</p>
                <div class="swal-title" style="padding:0px !important;">
                  `+this.helper.ifvalnull(data.TimeOut,'').substring(0,5)+`
                </div>
              </div>
          </div> 
          <p class="text-abu" style="font-size:12px;">
            Min Late <span style="color:black"> `+this.helper.ifvalnull(data.MinLate,'')+` </span>
          </p>
        </div> 
        <div style="display:inline-grid;grid-template-columns: calc(100% - 50px) 50px;width:100%;padding: 0px 40px;text-align: left;padding-top: 10px;">
          <div>
              <span style="font-size: 13px;"> Attachment </span>
              <p class="text-biru name-capture-img" style="margin: 0px;font-size: 12px;"> </p>
          </div>
          <div style="text-align: right;">
              <button class="btn-camera  item-button button button-ios button-default button-default-ios" style="background: #b5b9bc !important;font-size: 20px !important;padding: 0px !important;height: 30px !important;width: 40px;"><span
                      class="button-inner">
                      <ion-icon name="custom-camera" role="img" class="btn-capture-img icon icon-ios ion-ios-custom-camera"
                          aria-label="custom camera" ng-reflect-name="custom-camera"></ion-icon>
                  </span>
                  <div class="button-effect"></div>
              </button> 
          </div>
        </div>
        <div style="padding-top:10px">
          <label class="text-abu" style="padding-right:10px">Productivity</label>
          <input style="width: 40px;-webkit-appearance: none;background-color: #ebebeb;font-size: 14px;box-sizing: border-box;border: 1px solid rgba(0,0,0,.14);border-radius: 2px;transition: border-color .2s;
          padding: 5px !important;" max="3" type="number" name="productivity" id="input-productivity" value="`+
          this.helper.ifvalnull(data.Productivity,'0').replace("%","")+`"> <span class="text-abu">%</span>
        </div> 
      `;
      let options = {
        buttonConfirm : "Save",
        title         : "Detail",
        content       : element_content,
        eventListenerContent : true,
        cmpListeners : "progress-presensi",
      };
      this.helper.presentSwalCustomContent(options,(value) => {
        let params = {
          productivity : document.getElementById("input-productivity")['value'],
          date         : data.tgl,
          employee_id  : me.userApi.data.Employee_ID,
          employee_code: me.userApi.data.NIK,
          user_id      : me.userApi.data.id,
          file_name    : this.helper.imageNameSelected,
          binary_image : this.helper.imageSelected,
        };
        me.presensiProvider.changeProductivity(params).subscribe((resp ?: any) => {
          if (resp.success) {
            me.getAttendance();
            me.events.publish('presensi:reload');
          }
        });
      }); 
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/profil/detail_presensi/page.ts